
import { some } from "../fable-library-js.5.0.0/Option.js";
import { Operators_IsNull } from "../fable-library-js.5.0.0/FSharp.Core.js";

export function $007CNativeString$007C_$007C(x) {
    if (typeof (x) === 'string') {
        return x;
    }
    else {
        return undefined;
    }
}

export function $007CNativeBool$007C_$007C(x) {
    if (typeof (x) === 'boolean') {
        return x;
    }
    else {
        return undefined;
    }
}

export function $007CNativeNumber$007C_$007C(x) {
    if (typeof (x) === 'number') {
        return x;
    }
    else {
        return undefined;
    }
}

export function $007CNativeObject$007C_$007C(x) {
    if (typeof (x) === 'object') {
        return some(x);
    }
    else {
        return undefined;
    }
}

export function $007CNull$007C_$007C(x) {
    if (Operators_IsNull(x)) {
        return some(x);
    }
    else {
        return undefined;
    }
}

export function $007CNativeArray$007C_$007C(x) {
    if (Array.isArray(x)) {
        return x;
    }
    else {
        return undefined;
    }
}

